import { render, staticRenderFns } from "./crudProductSuppliersByBarcode.vue?vue&type=template&id=206bd808&scoped=true&"
import script from "./crudProductSuppliersByBarcode.vue?vue&type=script&lang=js&"
export * from "./crudProductSuppliersByBarcode.vue?vue&type=script&lang=js&"
import style0 from "./crudProductSuppliersByBarcode.vue?vue&type=style&index=0&id=206bd808&prod&scoped=true&lang=css&"
import style1 from "./crudProductSuppliersByBarcode.vue?vue&type=style&index=1&id=206bd808&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206bd808",
  null
  
)

export default component.exports